import {AccountEmailsSettingsDto} from "../../dtos";
import {Action} from "../actions/accountEmailsActions";
import {ActionType} from "../actionTypes";

const initialState: AccountEmailsSettingsDto = {
    loading: true,
    type: null,
    error: null,
    emails: {
        emailAddress1: "",
        emailAddress2: "",
        emailAddress3: "",
        emailAddress4: ""
    }
}

const reducer = (state: AccountEmailsSettingsDto = initialState, action: Action) => {

    switch(action.type)
    {
        //
        case ActionType.GET_ACCOUNT_EMAILS_SETTING_START:
        case ActionType.SET_ACCOUNT_EMAILS_SETTING_START:
            return { ...state, error: null, loading: true, type: action.type };

        case ActionType.GET_ACCOUNT_EMAILS_SETTING_SUCCESS:
        case ActionType.SET_ACCOUNT_EMAILS_SETTING_SUCCESS:
            return {
                ...state,
                emails: action.payload,
                error: null,
                loading: false,
                type: action.type
            };
        case ActionType.GET_ACCOUNT_EMAILS_SETTING_COMPLETE:
        case ActionType.SET_ACCOUNT_EMAILS_SETTING_COMPLETE:
            return { ... state, error: null, loading: false, type: action.type};

        case ActionType.GET_ACCOUNT_EMAILS_SETTING_ERROR:
        case ActionType.SET_ACCOUNT_EMAILS_SETTING_ERROR:
            return { ...state, error: action.payload, loading: false, type: action.type };

        default:
            return state;
    }
}

export default reducer;